import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { ControlCard } from '../../../components'
import { boardType } from '../../../constants';

const mapStateToProps = (state, ownProps) => {
  var newMoves, moves, type, gameInfo, editMode, operationMode
  const { width } = state.window
  if (ownProps.bid >= 0) {
    ({ type, moves, gameInfo, editMode, operationMode } = state.renjuBoardCards.cards[ownProps.bid])
    newMoves = type !== boardType.GAME_ROOM ?
      moves : moves.filter(move => move.datetime !== undefined)
  }

  return ({
    width,
    moves: newMoves,
    gameInfo,
    editMode,
    operationMode
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { bid } = ownProps
  return ({
    OpeningRuleControlBoxDispatch: {
      Soosyrv8Swap1BoxDispatch: {
        handleClickSwapButton: (swap) => () => {
          dispatch(actions.renjuBoardCard.changedSwap(bid, swap))
        },
      },
      Soosyrv8FiveMoveNumberBox: {
        handleChangedFiveMoveNumber: (event) => {
          dispatch(actions.renjuBoardCard.changedFiveMoveNumber(bid, event.target.value))
        },
        handleClickDecisionButton: (decisionType) => () => {
          dispatch(actions.renjuBoardCard.decision(bid, decisionType))
        },
      },
      Soosyrv8Swap2BoxDispatch: {
        handleClickSwapButton: (swap) => () => {
          dispatch(actions.renjuBoardCard.changedSwap(bid, swap))
        },
      },
      Soosyrv8FiveMovesBoxDispatch: {
        handleClickDecisionButton: (decisionType) => () => {
          dispatch(actions.renjuBoardCard.decision(bid, decisionType))
        },
      },
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ControlCard)



// WEBPACK FOOTER //
// ./src/containers/Common/RenjuBoardCard/ControlCard.js